import React, { useCallback, useEffect, useMemo } from "react";
import { useIntl } from "react-intl";
import {
  SocialProviderId,
  SocialProviderName,
} from "../../../../cores/socialPost/config";
import { SocialProvider } from "../../../../cores/socialPost/interfaces/socialProvider";
import { useMeCore } from "../../../../cores/me";
import { useYoutubeCore, isYoutubeConnected } from "../../../../cores/youtube";
import { YoutubeIcon } from "../../social/Youtube/YoutubeIcon";
import YoutubeAuthButton from "../../social/Youtube/YoutubeBindCard";
import SocialRow from "./SocialRow";

export const YouTubeBindRow: React.FC<{
  showIntegrationDescription?: boolean;
}> = ({ showIntegrationDescription }) => {
  const intl = useIntl();
  const { company } = useMeCore();
  const { get, settings } = useYoutubeCore();

  useEffect(() => {
    if (company?.id) get(String(company.id));
  }, [company, get]);

  const isActive = useMemo(() => isYoutubeConnected(settings), [settings]);

  const socialProvider = useMemo(
    (): SocialProvider => ({
      id: SocialProviderId.YouTube,
      name: SocialProviderName.YouTube,
      icon: <YoutubeIcon size="2x" active={isActive} />,
      displayName: settings?.channelName ?? settings?.name,
      avatar: settings?.avatarUrl,
      email: settings?.email,
    }),
    [settings, isActive]
  );

  return (
    <SocialRow
      social={socialProvider}
      bindLoading={false}
      getLoading={false}
      isSync={isActive}
      description={
        showIntegrationDescription
          ? intl.formatMessage({ id: "app.userIntegrations.youtubeDesc" })
          : undefined
      }
    >
      <div className="w-100 px-1">
        <YoutubeAuthButton />
      </div>
    </SocialRow>
  );
};
